module.exports = __webpack_public_path__ + "close.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/close.svg
// module id = 2222
// module chunks = 67